import React, { useCallback, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useShoppingCartStore } from '../../store/shoppingCart/shoppingCartStore';
import { BigButton } from '../BigButton';
import {
    BackgroundModal,
    ButtonsWrap,
    CloseModalButton,
    ModalContent,
    ModalWrapper,
    RemovingElementWrap,
} from './styles';
import animations from '../../helpers/animations';
import { AnimatePresence } from 'framer-motion';
import { useUserProfile } from '@/hooks/useUserData';

export const RemovingElementModal: React.FC = () => {
    const { removeCartValue } = useShoppingCartStore();
    const user = useUserProfile().data

    const {
        currentIdRemoving: idShopElement,
        nameRemovingElement: ticketName,
        setCurrentIdRemoving: setShowModal,
        scheduleId,
    } = useShoppingCartStore();

    function removeElementCart() {
        if (!idShopElement) return;
        removeCartValue(idShopElement, scheduleId || undefined, user?.accessProfile.name);
        setShowModal(null);
    }

    const modalRef = useRef<HTMLDivElement | null>(null);

    const closeModal = useCallback(
        (e: React.MouseEvent<HTMLDivElement>) => {
            if (modalRef.current === e.target) {
                setShowModal(null);
            }
        },
        [setShowModal]
    );

    const keyPress = useCallback(
        (e: KeyboardEvent) => {
            if (e.key === 'Escape' && !!idShopElement) {
                setShowModal(null);
            }
        },
        [setShowModal, idShopElement]
    );

    useEffect(() => {
        document.addEventListener('keydown', keyPress);

        return () => {
            document.removeEventListener('keydown', keyPress);
        };
    }, [keyPress, idShopElement]);

    return ReactDOM.createPortal(
        <AnimatePresence>
            {idShopElement && (
                <BackgroundModal
                    ref={modalRef}
                    onClick={closeModal}
                    {...animations.fadeInOut(.1)}
                >
                    <ModalWrapper>
                        <>
                            <p>Remover item do carrinho</p>
                            <CloseModalButton
                                onClick={() => setShowModal(null)}
                            />
                        </>
                        <ModalContent>
                            <RemovingElementWrap>
                                <span>
                                    Ao prosseguir com esta ação,{' '}
                                    <strong>{ticketName}</strong>{" "}
                                    será excluída do seu carrinho. Você tem
                                    certeza de que deseja continuar?
                                </span>

                                <ButtonsWrap>
                                    <BigButton
                                        color="primary"
                                        bgColor="secondary"
                                        onClick={removeElementCart}
                                        allWidth
                                    >
                                        Confirmar
                                    </BigButton>
                                    <BigButton
                                        color="primary"
                                        bgColor="primary"
                                        onClick={() => setShowModal(null)}
                                        allWidth
                                    >
                                        Cancelar
                                    </BigButton>
                                </ButtonsWrap>
                            </RemovingElementWrap>
                        </ModalContent>
                    </ModalWrapper>
                </BackgroundModal>
            )}
        </AnimatePresence>,
        document.body
    );
};
